<template>
  <modal
    class="app-main-modal"
    :class="{ '--mobile-modal': false }"
    :classes="classes"
    :name="name"
    :height="height"
    :width="width"
    :adaptive="true"
    :reset="false"
    :scrollable="isScrollable"
    @before-open="$emit('before-open')"
    @before-close="$emit('before-close')"
    @opened="opened"
    @closed="closed"
  >
    <slot name="container">
      <div class="app-main-modal__container">
        <button
          class="app-main-modal__close"
          :class="btnClasses"
          aria-label="close"
          type="button"
          @click.prevent="hide"
        ></button>
        <div v-if="isBody" class="app-main-modal__body">
          <slot name="body"></slot>
        </div>
        <slot name="body"></slot>
      </div>
    </slot>
  </modal>
</template>

<script>
export default {
  name: 'AppMainModal',
  props: {
    isScrollable: {
      type: Boolean,
      default: true,
    },
    isBody: {
      type: Boolean,
      default: true,
    },
    name: {
      type: String,
      default: '',
    },
    classes: {
      type: [String, Array, Object],
      default: 'app-main-modal__transparent',
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '100%',
    },
  },
  computed: {
    btnClasses() {
      return [
        {
          'app-main-modal__close--full-width': this.width === '100%',
        },
      ];
    },
  },
  methods: {
    hide() {
      this.$modal.hide(this.name);
      this.$emit('hide');
    },
    opened() {
      this.$emit('opened');
    },
    closed(event) {
      this.$emit('closed', event);
    },
  },
};
</script>

<style lang="scss">
.app-main-modal {
  &__close {
    position: absolute;
    top: 10px;
    right: 0;
    width: 30px;
    height: 30px;
    padding: 0;
    cursor: pointer;
    background-color: $color-transparent;
    border: 0;

    // @include media-xxs() {
    //   top: -7px;
    // }

    &::before,
    &::after {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 18px;
      height: 2px;
      content: '';
      background-color: $white;
      transition: background-color $transition-delay;
      transform: translate(-50%, -50%) rotate(45deg);
    }

    &::after {
      transform: translate(-50%, -50%) rotate(-45deg);
    }

    &:hover {
      &::before,
      &::after {
        background-color: $color-brand-green;
      }
    }

    &--full-width {
      top: 10px;
      right: 10px;
    }
  }

  &__container {
    height: 100%;
    padding: 40px 10px 20px;

    @include media-sm() {
      padding-bottom: 10px;
    }
  }

  &__body {
    height: 100%;
    overflow: auto;
    background-color: $color-white;
    border-radius: 3px;
  }

  &__transparent {
    background-color: $color-transparent;
  }
}
</style>
